import { Selector } from '@ngxs/store';
import { DirectoryHelperSelectors } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-helper/directory-helper.selectors';
import { SelectedSubscriberState } from 'src/app/store/samwin/directory/selected-subscriber/selected-subscriber.state';
import { EmailContact } from 'src/app/store/samwin/email/email-behaviour/email-contact';

export class SelectedSubscriberSelectors {
   @Selector([DirectoryHelperSelectors.emailsFromCustomColumns, SelectedSubscriberState.selectedSubscriberName])
   public static selectedSubscriberEmailOptions(emailsFromCustomColumns: string[], selectedSubscriberName: string): EmailContact[] {
      return emailsFromCustomColumns.map((entry) => new EmailContact(entry, selectedSubscriberName));
   }
}
